import {
  appVersion,
  carrierUri,
  coreApiRootUrl,
  shipperUri,
  VITE_ENV,
} from '@fv/client-core'

export { appVersion, carrierUri, shipperUri }
export const apiUri = `${coreApiRootUrl}/admin`

export const chrobinsonID = '5304f480259b15a354000028'
export const defaultPageSize = 20
export const environment = VITE_ENV
export const maxFileSize = 52428800 // 50 MB
export const siteTitle = 'Freightview Admin Tools'
